import React from 'react';
import classes from './ResetPasswordRequest.module.scss';
import { useAlert } from 'react-alert';
import { alertMessageTimeout as messageTimeout } from '../../molecules/AlertMessage/alertMessageTimeout';
import FormContainer from 'components/atoms/FormContainer/FormContainer';
import clsx from 'clsx';
import { LOGIN } from 'components/pages/pages';
import A from 'components/atoms/A/A';
import Txt from 'components/atoms/Txt/Txt';

import TextInput from '../../atoms/TextInput/TextInput';
import Form from '../../molecules/Form/Form';
import { submitResetPasswordRequest } from '../../templates/AuthenticationProvider/authApiUtils';
import { RequestPasswordResetError } from '../../templates/AuthenticationProvider/Types';
import usePromiseState from '../../../hooks/usePromiseState';
import useTranslate from 'hooks/useTranslate';

const ResetPasswordRequest: React.FC = () => {
  const alert = useAlert();
  const translate = useTranslate();
  const [email, setEmail] = React.useState('');
  const [handlePasswordResetRequest, resetPasswordRequestState] = usePromiseState(
    submitResetPasswordRequest,
  );
  const disabled = email.length === 0;

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleSubmitPress = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setEmail('');
    await handlePasswordResetRequest(email.trim().toLocaleLowerCase())
      .then((response) => {
        alert.show(response.message, {
          type: 'success',
          timeout: messageTimeout(response.message),
        });
      })
      .catch((err: RequestPasswordResetError) => {
        alert.show(
          err.updateError ||
            translate(
              'You have been temporarily blocked for security reasons for up to 72 hours, please try resetting your password later',
            ),
          {
            type: 'error',
            timeout: messageTimeout(err.updateError),
          },
        );
      });
  };

  const emailInputSettings = {
    onChange: handleEmailChange,
    type: 'text',
    id: 'Request-Password-Reset-form-email',
    title: '',
    value: email,
    placeholder: 'Enter your account email',
    autoComplete: 'username',
  };

  return (
    <section className={clsx(classes.root, 'fadedPageBg')}>
      <div className={classes.formWidthContainer}>
        <FormContainer
          isFullPage={true}
          title="Forgot Password?"
          subtitle="No worries, we'll send you reset instructions"
        >
          <Form
            submitDisabled={disabled || resetPasswordRequestState.isLoading}
            onSubmit={handleSubmitPress}
            submitName="Reset Password"
            submitButtonType="primary"
            submitButtonColor="secondary"
            buttonWrapperClassName={classes.buttonWrapper}
            submitButtonFullWidth
          >
            <TextInput inputClassName={classes.input} {...emailInputSettings} />
          </Form>
          <Txt component={A} to={LOGIN.path} className={classes.lowerLink}>
            Back to login
          </Txt>
        </FormContainer>
      </div>
    </section>
  );
};

export default ResetPasswordRequest;
